import React, { useCallback, useMemo, useState } from "react";

const IOS_STORE = "https://apps.apple.com/tr/app/eventle/id6474272088?l=tr";
const ANDROID_STORE = "https://play.google.com/store/apps/details?id=com.eventle.eventle&hl=tr";

function getAppPath() {
  const path = window.location.pathname + window.location.search + window.location.hash;
  return path || "/home";
}

export default function OpenAppButton() {
  const [trying, setTrying] = useState(false);

  const ua = useMemo(() => {
    // no TS assertions here
    const anyWindow = typeof window !== "undefined" ? window : {};
    return navigator.userAgent || navigator.vendor || anyWindow.opera || "";
  }, []);

  const isAndroid = /android/i.test(ua);
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

  const appScheme = useMemo(() => `eventlelink://${getAppPath()}`, []);
  const androidIntentHref = useMemo(() => {
    const path = encodeURIComponent(getAppPath());
    const fallback = encodeURIComponent(ANDROID_STORE);
    return `intent://open?path=${path}#Intent;scheme=eventlelink;package=com.eventle.eventle;S.browser_fallback_url=${fallback};end`;
  }, []);

  const handleClick = useCallback(() => {
    setTrying(true);

    if (isAndroid) {
      window.location.href = androidIntentHref;
      return;
    }

    if (isIOS) {
      const start = Date.now();
      const timer = setTimeout(() => {
        if (Date.now() - start < 2000) {
          window.location.href = IOS_STORE;
        }
      }, 1200);

      const onVisibility = () => {
        if (document.visibilityState === "hidden") {
          clearTimeout(timer);
          cleanup();
        }
      };
      const cleanup = () => {
        document.removeEventListener("visibilitychange", onVisibility);
        setTrying(false);
      };
      document.addEventListener("visibilitychange", onVisibility);

      window.location.href = appScheme;
      setTimeout(cleanup, 3000);
      return;
    }

    window.location.href = IOS_STORE;
  }, [isAndroid, isIOS, androidIntentHref, appScheme]);

  return (
    <button
      onClick={handleClick}
      style={{
        backgroundColor: "#6535F3",
        color: "white",
        border: "none",
        padding: "12px 24px",
        borderRadius: "25px",
        fontSize: 16,
        fontWeight: "bold",
        cursor: "pointer",
      }}
    >
      {trying ? "Açılıyor…" : "Uygulamada Aç"}
    </button>
  );
}
